import React from "react";
import Footer from "../components/footer";
import Header from "../components/header";

export default function team() {
  // Ekip üyeleri verisi
  const teamMembers1 = [
    {
      id: 1,
      name: "Oğuzhan BAHADIR",
      title: "Founder & CEO",
      image: "/assets/team/qriendTeamOguzhan.jpeg",
    },
    {
      id: 2,
      name: "Mert AKGÜN",
      title: "Frontend Developer",
      image: "/assets/team/qriendTeamMert.jpg",
    },
    {
      id: 3,
      name: "Enes ŞİŞKO",
      title: "Backend Developer",
      image: "/assets/team/qriendTeamEnes.jpg",
    },
    {
      id: 4,
      name: "Minel SEVGEN",
      title: "Frontend Developer",
      image: "/assets/team/qriendTeamMinel.jpeg",
    },
    {
      id: 5,
      name: "Sıla KOÇ",
      title: "UI/UX Designer",
      image: "/assets/team/qriendTeamSıla.jpeg",
    },
  ];

  const teamMembers2 = [
    {
      id: 6,
      name: "Ada ULU",
      title: "Social Media & Digital Marketing",
      image: "/assets/team/qriendTeamAda.jpg",
    },
    // {
    //   id: 7,
    //   name: "Sıla KOÇ",
    //   title: "UI/UX Designer",
    //   image: "/assets/team/qriendTeamSıla.jpeg",
    // },

    {
      id: 8,
      name: "Engincan ARAZ",
      title: "Frontend Developer",
      image: "/assets/team/qriendTeamEngincan.png",
    },

    {
      id: 9,
      name: "Enes Varım",
      title: "Backend Developer",
      image: "/assets/team/qriendTeamEnesVarım.jpeg",
    },
  ];

  return (
    <div className="flex flex-col min-h-screen bg-white  ">
      {/* Header */}
      <Header isHomePage={false} />
      {/* Hero Section */}
      <section className="relative w-full h-[440px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/assets/premium-plan.png"
            alt="Ekibimiz"
            className="w-full h-full object-cover object-center"
            loading="lazy"
          />
        </div>
        <div className="absolute inset-0 flex items-end">
          <div className="container mx-auto px-4 sm:px-6 md:px-8 pb-4 sm:pb-8 md:pb-12 lg:pb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-[54px] font-medium font-poppins text-white text-center sm:text-left max-w-xs sm:max-w-sm md:max-w-2xl mx-auto sm:mx-0">
              Ekibimiz
            </h2>
          </div>
        </div>
      </section>

      {/* Ekip Sayfası */}
      <section className="relative overflow-hidden z-100 bg-[#121212]  ">
        <div className="py-12 sm:py-10 lg:py-15">
          <div className="min-h-screen text-white py-12 px-4 md:px-8">
            <div className="max-w-7xl mx-auto ">
              {/* Birinci Satır */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-12 ">
                {teamMembers1.map((member) => (
                  <div key={member.id} className="flex flex-col h-full ">
                    <div className="w-full rounded-t-xl h-[558px] sm:h-[558px] md:h-80 overflow-hidden bg-gray-200 ">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover object-center "
                      />
                    </div>
                    <div className="mt-2">
                      <h3 className="text-xl font-bold">{member.name}</h3>
                      <p className="text-sm mt-1">{member.title}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* İkinci Satır */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-12">
                {teamMembers2.map((member) => (
                  <div key={member.id} className="flex flex-col h-full">
                    <div className="w-full rounded-t-xl h-[558px] sm:h-[558px] md:h-80 overflow-hidden bg-gray-200">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    <div className="mt-2">
                      <h3 className="text-xl font-bold">{member.name}</h3>
                      <p
                        className={`text-sm mt-1 ${
                          member.id === 6 ? "md:truncate" : ""
                        }`}
                      >
                        {member.title}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer isHomePage={false} />
    </div>
  );
}
